/// <reference path="../../polaris-web-components.d.ts" />

import { useState, useCallback, useEffect } from 'react';

export function MappingTabs({ tabs = [], selected = 0, onSelect, fitted = false, children }) {
  const [activeTab, setActiveTab] = useState(selected);
  useEffect(() => {
    setActiveTab(selected);
  }, [selected]);

  const handleTabClick = useCallback((index) => {
    setActiveTab(index);
    if (onSelect) {
      onSelect(index);
    }
  }, [onSelect]);

  return (
    <>
      <s-stack direction="inline" alignItems="center" gap="base" padding="base">
        {tabs.map((tab, index) => {
          const isActive = index === activeTab;
          return (
            <s-box
              padding="none"
              background={isActive ? 'subdued' : 'transparent'}
              border={isActive ? 'base' : 'none'}
              borderRadius={isActive ? 'base' : 'none'}
            >
              <s-button
                variant="tertiary"
                onClick={() => handleTabClick(index)}
              >
                {tab.content}
              </s-button>
            </s-box>
          );
        })}
      </s-stack>

      {children}
    </>
  );
}


export function TabPanel({ children }) {
  return <>{children}</>;
}

export default MappingTabs;
